module.exports = __webpack_public_path__ + "static/media/icon-nav-compra-venta.74512c5f.svg";